import { httpClient } from '@/services/client/http-client'

export const __cBotService = {
  sendErrorNotice: async (message: string) => {
    const response = await httpClient.DIRECT.post('/api/bot-notice', {
      message,
      type: 'text',
    })
    return response
  },
}
